export default __webpack_public_path__ + "static/media/notfound.cb049ab8.gif";